export default "__VITE_ASSET__DESJKL79__"